module.exports = __webpack_public_path__ + "static/coworking-mob-e961fe7db807f610be667fcc6613293c.jpg";